import { ActivityWithRelations } from '@/utils/types';
import { endOfDay, startOfDay } from 'date-fns';
import { create } from 'zustand';
import { createMapArrayCache } from './mapArrayCache';

interface ActivityState {
  activities: Map<string, ActivityWithRelations>;
  lastSyncAt: number;
  mergeActivities: (newActivities: ActivityWithRelations[]) => void;
  clearActivities: () => void;
  touchActivities: () => void;
  getFilteredActivities: (range?: {
    start: Date;
    end: Date;
  }) => ActivityWithRelations[];
}

const getActivitiesArray = createMapArrayCache<string, ActivityWithRelations>();

export const useActivityStore = create<ActivityState>((set, get) => ({
  activities: new Map(),
  lastSyncAt: 0,

  mergeActivities: (newActivities) => {
    set((state) => {
      const updatedMap = new Map(state.activities);
      newActivities.forEach((activity) => {
        updatedMap.set(activity.id.toString(), activity);
      });
      return { activities: updatedMap };
    });
  },

  clearActivities: () => {
    set({ activities: new Map(), lastSyncAt: Date.now() });
  },

  touchActivities: () => {
    set({ lastSyncAt: Date.now() });
  },

  getFilteredActivities: (range) => {
    const activities = getActivitiesArray(get().activities);

    if (!range) {
      return activities;
    }

    const rangeStart = startOfDay(range.start);
    const rangeEnd = endOfDay(range.end);

    return activities.filter((activity) => {
      if (!activity.startDate) return false;
      const activityDate =
        typeof activity.startDate === 'string'
          ? new Date(activity.startDate)
          : activity.startDate;
      return activityDate >= rangeStart && activityDate <= rangeEnd;
    });
  },
}));
